/**
 * Běží aplikace jako instalace na ploše (standalone), ne jako záložka?
 *
 * Ptát se jen přes `navigator.standalone` je past. Je to proprietární relikt
 * Applu, který nikdy nebyl ve standardu a stojí a padá s tím, jestli ho zrovna
 * podporuje aktuální iOS. Standardní odpověď dává media query
 * `display-mode: standalone`, kterou umí i Android a desktop.
 *
 * Proč na tom záleží: push na iOS se přihlašuje jen z instalace na ploše, takže
 * tahle jediná podmínka rozhoduje, jestli se odběr vůbec založí. Když vrátila
 * `false` omylem, aplikace se **tiše** přestala přihlašovat — žádná chyba,
 * žádný banner, jen ticho. Po upgradu iOS tím zmizely notifikace a nebylo
 * podle čeho poznat proč (vadilo `navigator.standalone` samotné v app.jsx,
 * zatímco instalační banner vedle toho kontroloval obojí).
 *
 * `minimal-ui` a `fullscreen` počítáme taky — jsou to instalované režimy,
 * jen s jinou dekorací okna.
 */
export default function naPloše() {
    if (typeof window === 'undefined') return false;
    // Pořadí záleží: standardní odpověď první, legacy jen jako záchrana pro
    // starší iOS, kde media query nemusí být spolehlivá.
    const rezimy = ['standalone', 'minimal-ui', 'fullscreen'];
    if (rezimy.some(r => window.matchMedia?.(`(display-mode: ${r})`)?.matches)) return true;
    return window.navigator.standalone === true;
}
